import React, { createContext, useMemo } from 'react';

import { useEnvironment } from '@wix/yoshi-flow-editor';

import { createSiteEcomService, SiteEcomService } from '@/services/siteEcom';
import {
  createDuplexerConnection,
  DuplexerConnection,
} from '@/services/duplexer';

import { SiteEcomApi } from 'AiAssistantWidget/types';

interface WidgetServices {
  siteEcomService: SiteEcomService;
  duplexerConnection: null | DuplexerConnection;
}
const ServicesContext = createContext<WidgetServices>({
  get siteEcomService(): SiteEcomService {
    throw new Error('siteEcomService is not provided');
  },
  get duplexerConnection(): DuplexerConnection {
    throw new Error('duplexerConnection is not provided');
  },
});

export const WidgetServicesProvider: React.FC<{
  instance?: string;
  duplexerConnection?: DuplexerConnection;
  ecom: SiteEcomApi;
}> = ({ children, instance, ecom, ...provided }) => {
  const { isEditor } = useEnvironment();

  const siteEcomService = createSiteEcomService(ecom);

  const duplexerConnection = useMemo(() => {
    if (provided.duplexerConnection) {
      return provided.duplexerConnection;
    }

    if (isEditor || !instance) {
      return null;
    }

    return createDuplexerConnection(instance);
  }, [instance, isEditor, provided.duplexerConnection]);

  return (
    <ServicesContext.Provider
      value={{
        siteEcomService,
        duplexerConnection,
      }}
    >
      {children}
    </ServicesContext.Provider>
  );
};

export const useWidgetServices = (): WidgetServices =>
  React.useContext(ServicesContext);
